module.exports = __webpack_public_path__ + "img/file-presentation.5ffa4003.svg";